module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "course-admin"
  }, [(_vm.course) ? _c('div', [_c('div', {
    staticClass: "panel col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("\n                " + _vm._s(_vm.course.name) + "\n                "), (_vm.course.coreCurriculum) ? _c('span', {
    staticClass: "core-curriculum"
  }, [_vm._v("Core Curriculum")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(_vm.$route.query.path_name && _vm.$route.query.term_name) ? _c('h5', [_vm._v("\n                " + _vm._s(_vm.$route.query.path_name) + " (" + _vm._s(_vm.$route.query.term_name) + ")\n            ")]) : _vm._e(), _vm._v(" "), _c('vue-html5-editor', {
    attrs: {
      "content": _vm.courseDescription
    },
    on: {
      "change": _vm.updateCourseDescription
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "core-curriculum-setting"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.course.coreCurriculum),
      expression: "course.coreCurriculum"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.course.coreCurriculum) ? _vm._i(_vm.course.coreCurriculum, null) > -1 : (_vm.course.coreCurriculum)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.course.coreCurriculum,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.course.coreCurriculum = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.course.coreCurriculum = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.course.coreCurriculum = $$c
        }
      }
    }
  }), _vm._v("This course is part of the core curriculum, and should be included in attendance records")])]), _vm._v(" "), _c('div', {
    staticClass: "core-curriculum-setting"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.course.scheduledHours),
      expression: "course.scheduledHours"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "1"
    },
    domProps: {
      "value": (_vm.course.scheduledHours)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.course.scheduledHours = $event.target.value
      }
    }
  }), _vm._v(" Scheduled hours\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updateCourse()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('label', {
    attrs: {
      "for": "course-image"
    }
  }, [_c('i', {
    staticClass: "fa fa-edit add-image"
  }), _vm._v(" "), _c('input', {
    ref: "courseImage",
    staticClass: "course-image-file",
    attrs: {
      "type": "file",
      "id": "course-image"
    },
    on: {
      "change": function($event) {
        _vm.setCourseImage()
      }
    }
  })]), _vm._v(" "), (_vm.course.image) ? _c('img', {
    staticClass: "course-image",
    attrs: {
      "src": _vm.course.image
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.lessonToClone) ? _c('lesson-cloner', {
    attrs: {
      "lesson": _vm.lessonToClone
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12  panel"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered lessons-table"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.videos), function(video, index) {
    return _c('tr', [_c('td', [(_vm.editingVideo === false) ? _c('span', [_vm._v(_vm._s(video.title))]) : _vm._e(), _vm._v(" "), (_vm.editingVideo === true) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (video.title),
        expression: "video.title"
      }],
      staticClass: "form-control",
      domProps: {
        "value": (video.title)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          video.title = $event.target.value
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', [(_vm.editingVideo === false) ? _c('span', [_vm._v(_vm._s(video.sku))]) : _vm._e(), _vm._v(" "), (_vm.editingVideo === true) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (video.sku),
        expression: "video.sku"
      }],
      staticClass: "form-control",
      domProps: {
        "value": (video.sku)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          video.sku = $event.target.value
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', [(_vm.editingVideo === false) ? _c('span', [_vm._v(_vm._s(video.week))]) : _vm._e(), _vm._v(" "), (_vm.editingVideo === true) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (video.week),
        expression: "video.week"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          video.week = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, _vm._l((_vm.weeks), function(week) {
      return _c('option', [_vm._v(_vm._s(week))])
    })) : _vm._e()]), _vm._v(" "), _c('td', [(_vm.editingVideo === false) ? _c('span', [_vm._v(_vm._s(video.weekAvailable))]) : _vm._e(), _vm._v(" "), (_vm.editingVideo === true) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (video.weekAvailable),
        expression: "video.weekAvailable"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          video.weekAvailable = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, _vm._l((_vm.weeks), function(week) {
      return _c('option', [_vm._v(_vm._s(week))])
    })) : _vm._e()]), _vm._v(" "), _c('td', {
      style: ({
        'background': video.color
      })
    }, [(_vm.editingVideo === false) ? _c('span') : _vm._e(), _vm._v(" "), (_vm.editingVideo === true) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (video.color),
        expression: "video.color"
      }],
      attrs: {
        "type": "color"
      },
      domProps: {
        "value": (video.color)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          video.color = $event.target.value
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.editingVideo === true) ? _c('i', {
      staticClass: "fa fa-remove cursor-pointer",
      on: {
        "click": function($event) {
          $event.preventDefault();
          video.color = null
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', [(_vm.editingVideo === false) ? _c('span', [_vm._v(_vm._s(video.instructorName))]) : _vm._e(), _vm._v(" "), (_vm.editingVideo === true) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (video.instructorName),
        expression: "video.instructorName"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (video.instructorName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          video.instructorName = $event.target.value
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn btn-xs btn-danger",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.deleteVideo(video.id, index, video.instanceId, video.week)
        }
      }
    }, [_vm._v("Delete")])]), _vm._v(" "), _c('td', [(_vm.editingVideo === false) ? _c('button', {
      staticClass: "btn btn-xs btn-warning",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.editingVideo = true
        }
      }
    }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), (_vm.editingVideo === true) ? _c('button', {
      staticClass: "btn btn-xs btn-success",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.updateVideo(index)
        }
      }
    }, [_vm._v("Save")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'videoChapters',
          params: {
            courseId: video.courseId,
            instanceId: _vm.instanceId,
            videoId: video.id
          },
          query: {
            path: _vm.$route.query.path_name,
            term: _vm.$route.query.term_name,
            week: video.week
          }
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-sm btn-warning"
    }, [_vm._v("Videos")])])], 1), _vm._v(" "), _c('td', {
      staticClass: "flex"
    }, [(video.exercise) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'handins',
          params: {
            exerciseId: video.exercise.id
          }
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-sm btn-warning"
    }, [_vm._v("Hand-Ins")])]) : _vm._e(), _vm._v(" "), _c('i', {
      staticClass: "fa fa-copy",
      on: {
        "click": function($event) {
          _vm.lessonToClone = video
        }
      }
    })], 1)])
  }))]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.addVideo()
      }
    }
  }, [_c('h4', [_vm._v("Add Weekly Lesson")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.video.title),
      expression: "video.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.video.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.video.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Week")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.video.week),
      expression: "video.week"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.video.week = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.setWeekAvailable()
      }]
    }
  }, _vm._l((_vm.weeks), function(week) {
    return _c('option', [_vm._v(_vm._s(week))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Week Available")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.video.weekAvailable),
      expression: "video.weekAvailable"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.video.weekAvailable = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.weeks), function(week) {
    return _c('option', [_vm._v(_vm._s(week))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("SKU")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.video.sku),
      expression: "video.sku"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.video.sku)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.video.sku = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Assign to")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.video.instructorName),
      expression: "video.instructorName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.video.instructorName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.video.instructorName = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), (_vm.videosForImport) ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.importVideo()
      }
    }
  }, [_c('h4', [_vm._v("\n                    Import Lesson\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Week")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.importedVideo.week),
      expression: "importedVideo.week"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.importedVideo.week = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.weeks), function(week) {
    return _c('option', [_vm._v(_vm._s(week))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Video")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.importedVideo.id),
      expression: "importedVideo.id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.importedVideo.id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.videosForImport), function(video) {
    return _c('option', [_vm._v("\n                            " + _vm._s(video.title) + "\n                        ")])
  }))])]) : _vm._e()])])], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Set Your Course Image which will be displayed in various areas!"), _c('br'), _vm._v("Pick something representative of your course!")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Weekly Lessons")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("SKU")]), _vm._v(" "), _c('th', [_vm._v("Week")]), _vm._v(" "), _c('th', [_vm._v("Available")]), _vm._v(" "), _c('th', [_vm._v("Colour")]), _vm._v(" "), _c('th', [_vm._v("Instructor")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Edit")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Add")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-401f4cba!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CourseAdmin.vue
// module id = 2031
// module chunks = 2